<template>
    <section class="page-section page-section--last">
        <div class="mb-60 mb-md-30">
            <div class="mb-10"><h3 class="text-28 text-md-20">전자혁신 제조지원 사업</h3></div>
            <div class="row">
                <div class="col-12 col-lg-6 order-lg-2">
                    <div class="img-wrap text-lg-right">
                        <img src="/images/sub/about/business-img.png" alt="이미지" />
                    </div>
                </div>
                <div class="col-12 col-lg-6 order-lg-1">
                    <div class="text-items">
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>사업명</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text">전자혁신 제조지원 사업</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>사업기간</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text">’21.4.1 ~ ’23.12.31 (3년)</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>지원내용</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text line-height-18">빠른 제조, 부품지원, 상품화 등 전자제조서비스 지원</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>사업목표</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text line-height-18">도심 내 전자혁신제조 플랫폼 구축으로 해외 이탈 전자 제조 수요를 국내로 복귀하여 전자제조 산업 르네상스 실현</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="mb-30 mb-md-15">
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">1 </strong>비전</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <p class="card--shadow__txt page-text"><span class="color-primary">혁신제품 창출과 빠른지원을 통해 전자제조강국</span>에 기여한다.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-30 mb-md-15">
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">2 </strong>목표</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <p class="card--shadow__txt page-text">
                                <span class="color-primary">용산 [팩토리77] 구축을 통해 전자제조 집적화 확보</span> 및 용산 전자 집적화를 통한 혁신제품 개발 생태계 확보
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-30 mb-md-15">
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">3 </strong>전략</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <div class="card--shadow__txt page-text">
                                <p>1. 뉴 트랜드 제품기반의 빠른 생산 시스템 구축</p>
                                <p>2. 도심 내 제조 생태계를 위한 도시재생+산업재건 진행</p>
                                <p>3. 빠른 디버깅이 가능한 인력+장비 공간 구축</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">4 </strong>구성</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <div class="card--shadow__txt page-text">
                                <p>1. 빠른 제조를 통한 초도양산 지원</p>
                                <p>2. 엔지니어 상주를 통한 직접 기술 지원 (언제니어+전문지원단)</p>
                                <p>3. 개발자를 위한 제조 지원 인프라 지원</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style></style>
